// extracted by mini-css-extract-plugin
module.exports = {"map":"Animation_map__22S-K","wrapper":"Animation_wrapper__113WM","tight":"Animation_tight__2w5mr","absolute":"Animation_absolute__5QLqU","fill":"Animation_fill__1TtQq"};